import { render, staticRenderFns } from "./salinvoicebycustchange.vue?vue&type=template&id=16cb154c&scoped=true&"
import script from "./salinvoicebycustchange.vue?vue&type=script&lang=js&"
export * from "./salinvoicebycustchange.vue?vue&type=script&lang=js&"
import style0 from "./salinvoicebycustchange.vue?vue&type=style&index=0&id=16cb154c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb154c",
  null
  
)

export default component.exports